export default [
  {
    path: '/chongqing',
    name: "chongqing",
    component: () => import('../views/chongqing/start.vue'),
    children: [
      {
        path: 'yuxing',
        name: "CQYuxing",
        component: () => import('../views/chongqing/yuxing.vue'),
        meta: {
          title: '渝星卡-仅限重庆市'
        }
      },
      {
        path: 'protocol',
        name: 'CQProtocol',
        component: () => import('../views/chongqing/protocol.vue'),
      },
      {
        path: 'yuxing/success',
        name: 'CQYuxingSuccess',
        component: () => import('../views/chongqing/yuxingSuccess.vue'),
        meta: {
          title: '领取成功'
        }
      },
      {
        path: 'flow',
        name: "CQFlow",
        component: () => import('@/views/chongqing/flow.vue'),
        meta: {
          title: '重庆移动用户专享'
        }
      },
      {
        path: 'marflow',
        name: "CQMarFlow",
        component: () => import('@/views/chongqing/marflow.vue'),
        meta: {
          title: '重庆移动用户专享'
        }
      },
      {
        path: 'margreenflow',
        name: "CQMarGreenFlow",
        component: () => import('@/views/chongqing/margreenflow.vue'),
        meta: {
          title: '重庆移动用户专享'
        }
      },
      {
        path: 'marredflow',
        name: "CQMarRedFlow",
        component: () => import('@/views/chongqing/marredflow.vue'),
        meta: {
          title: '重庆移动用户专享'
        }
      },
      {
        path: 'commonSuccess',
        name: "CQFlowCommonSuccess",
        component: () => import('@/views/chongqing/commonSuccess.vue'),
        meta: {
          title: '办理成功'
        }
      },
      {
        path: 'adSuccess',
        name: "CQFlowADSuccess",
        component: () => import('@/views/chongqing/adSuccess.vue'),
        meta: {
          title: '办理成功'
        }
      }
    ]
  }
]